const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export const email = value =>
    value && !emailRegex.test(value) ? `Invalid email address` : undefined;

// Will return true if value is required
export const required = value =>
    ( value || value === 0 ) && value.toString().trim() ? false : true;
